import { render, staticRenderFns } from "./NotificationEventSettingsTable.vue?vue&type=template&id=1705d76b&scoped=true"
import script from "./NotificationEventSettingsTable.vue?vue&type=script&lang=js"
export * from "./NotificationEventSettingsTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationEventSettingsTable.vue?vue&type=style&index=0&id=1705d76b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1705d76b",
  null
  
)

export default component.exports